export const getStudents = () => {
    // Vite glob import to find all images in the avatars folder
    const modules = import.meta.glob('../assets/avatars/*.{png,jpg,jpeg,webp}', { eager: true });

    const students = Object.keys(modules).map(path => {
        // Extract filename from path (e.g., "../assets/avatars/Juan.png" -> "Juan")
        const fileName = path.split('/').pop();

        const name = fileName.substring(0, fileName.lastIndexOf('.'));
        // Use public absolute path which works on Netlify and Dev
        const avatarSrc = `/avatars/${name}.webp`;

        return {
            id: name,
            name: name,
            avatar: avatarSrc
        };
    });

    return students.sort((a, b) => a.name.localeCompare(b.name));
};
